<table
mat-table
[dataSource]="dataSource"
class="mat-elevation-z8 bg-transparent w-full relative"
>
<ng-container matColumnDef="NameEN">
	<th mat-header-cell *matHeaderCellDef>
		<span class="text-medium-gray px-3">{{
			'STORE.CATEGORY_LIST.ENGLISH_NAME' | translate
		}}</span>
	</th>
	<td 
	
		*matCellDef="let data"
		class="p-0 {{data.parentId == null ? 'border-b-[1px] border-secondry-color-Gray bg-grey-background':'custom-cell  custom-cell-ar'}} h-[52px] {{
			data.parentId == null ? ' ltr:ml-[25px] rtl:mr-[25px]' : ''
		}}"
	>
		<div class="cell-content">
			<button
				mat-icon-button
				(click)="treeControl.toggle(data)"
				class=" h-[52px]  {{data.parentId == null ? 'border-b-[1px] border-secondry-color-Gray':''}}  {{
					!data.expandable && data.parentId != null
						? 'bg-white text-white w-[25px] rounded-none p-0 ltr:left-b'
						: ' text-main-color-black'
				}} "
			>
				<mat-icon
					class="mat-icon-rtl-mirror  {{
						!data.expandable ? 'hidden' : ' '
					}}"
				>
					{{
						treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'
					}}
				</mat-icon>
			</button>
			<img
				*ngIf="data.parentId == null"
				[src]="attachmentUrl+data.imageUrl"
				alt=""
				class="w-[46px] h-[46px] ltr:mr-2 rtl:ml-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
			/>

			<div
				class="cell-text  h-[55px] bg-grey-background w-full pt-[15px] {{
					data.parentId == null
						? 'text-main-color-black'
						: 'text-medium-gray ltr:pl-3 rtl:pr-3 ltr:border-l-[1px] ltr:border-l-secondry-color-Gray rtl:border-r-[1px] rtl:border-r-secondry-color-Gray'
				}}"
				>{{ data?.name?.en }}</div
			>
		</div>
	</td>
</ng-container>

<ng-container matColumnDef="NameAr">
	<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
		{{ 'STORE.CATEGORY_LIST.ARABIC_NAME' | translate }}
	</th>
	<td
		mat-cell
		*matCellDef="let data"
		class="border-b-[1px] border-secondry-color-Gray bg-grey-background {{
			data.parentId == null ? 'text-main-color-black' : 'text-medium-gray ltr:pl-5 rtl:pr-5 '
		}}"
	>
		{{ data?.name?.ar }}
	</td>
</ng-container>
<ng-container matColumnDef="count">
	<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
		{{ 'STORE.CATEGORY_LIST.PRODUCTS' | translate }}
	</th>
	<td
		mat-cell
		*matCellDef="let data"
		class="border-b-[1px] border-secondry-color-Gray bg-grey-background {{
			data.parentId == null ? 'text-main-color-black' : 'text-medium-gray ltr:pl-5 rtl:pr-5 '
		}}"
	>
		{{ data.products }}
	</td>
</ng-container>

<ng-container matColumnDef="activation">
	<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
		{{ 'STORE.CATEGORY_LIST.ACTIVATION' | translate }}
	</th>
	<td
		mat-cell
		*matCellDef="let data"
		class="border-b-[1px] border-secondry-color-Gray bg-grey-background"
	>
		<mat-slide-toggle
			(change)="activationState.emit(data)"
			[checked]="data?.isActive"
		></mat-slide-toggle>

		<span
			[ngClass]="data?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'"
			class="inline-block mx-[16px] max-mobile:text-font-mobile-small align-top"
		>
			{{
				data?.isActive
					? ('ACTIONS.ACTIVE' | translate)
					: ('ACTIONS.INACTIVE' | translate)
			}}
		</span>
	</td>
</ng-container>

<ng-container matColumnDef="a">
	<th mat-header-cell *matHeaderCellDef class="text-medium-gray"></th>
	<td 	mat-cell
	*matCellDef="let data"
	class="border-b-[1px] border-secondry-color-Gray bg-grey-background">
		<div class="max-mobile:w-[20px] flex gap-2 ">
			<p
				class="mt-4 text-medium-gray cursor-pointer"
				*ngIf="data.parentId == null "
				(click)="addEditSubCategory(data, 'add')"
			>
				+
			</p>
			<img
		
				(click)="addEditSubCategory(data, 'edit')"
				[src]="'assets/images/edit.svg'"
				alt=""
				class="inline-block cursor-pointer w-[16px]"
			/>
			<img
				*ngIf="data.canDelete"
				(click)="deleteCategory(data)"
				class="inline-block cursor-pointer w-[16px]"
				[src]="'assets/images/delete.svg'"
				alt=""
			/>
		</div>
	</td>
</ng-container>

<tr
	mat-header-row
	*matHeaderRowDef="displayedColumns"
	class=""
></tr>
<tr
	mat-row
	*matRowDef="let row; columns: displayedColumns"
	class=" h-[52px]"
></tr>
</table>